import React, { ReactElement } from 'react';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { JourneePedagogique } from '../../../../../common/src/entities';
import { ChampsJourneePedagogique } from './DetailsJourneePedagogique';

/**
 * Page de création d'une entité JourneePedagogique contenant le formulaire à remplir
 *
 * @returns page html du formulaire
 */
export default function CreerJourneePedagogique(props: Partial<PropsDeCreationEntite<JourneePedagogique>>): ReactElement {
    
    return (
        <FormulaireCreationEntite
            texteEntete={(t: JourneePedagogique) =>
                <small className="text-muted">Création d&apos;une nouvelle journée</small>
            }
            entite={JourneePedagogique}
            {...props}
        >
            <ChampsJourneePedagogique />
        </FormulaireCreationEntite>
    );
}